import { AnimatedGrid } from '../AnimatedSection';
import styles from './index.module.scss';

interface CommonTitleProps {
    title: string;
    desc?: string;
    sub_title?: string;
}

const CommonTitle: React.FC<CommonTitleProps> = ({ title, desc, sub_title }) => {
    return (
        <AnimatedGrid className={styles.CommonTitle + ' d3m-title-common eco-section-common'} variant="fadeInUp" options={{ delay: 100, stagger: 0.25 }}>
            <div className="eco-section-title">{title}</div>
            {sub_title && <div className="section-sub-title">{sub_title}</div>}
            <div className="eco-section-desc">{desc}</div>
        </AnimatedGrid>
    );
};

export default CommonTitle;
